// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e5487946","239":"04c767de","453":"7d94590f","667":"45b56473"}[chunkId] + ".chunk.js";
};